import { ResourceSelectionMode } from "../../GeneratedGraphQL";

type GetMicrositeResourceSelectionModeOps = {
  allowResourceGroupSelection: boolean;
  allowResourceSelection: boolean;
};

/**
 * Converts the two boolean settings for the microsite into
 * the single enum for resource selection mode.
 */
export const getMicrositeResourceSelectionMode = (
  options: GetMicrositeResourceSelectionModeOps,
) => {
  const { allowResourceGroupSelection, allowResourceSelection } = options;

  if (!allowResourceSelection && !allowResourceGroupSelection) {
    return ResourceSelectionMode.Disabled;
  }

  if (allowResourceSelection && allowResourceGroupSelection) {
    return ResourceSelectionMode.ResourceByGroup;
  }

  if (!allowResourceSelection && allowResourceGroupSelection) {
    return ResourceSelectionMode.Group;
  }

  return ResourceSelectionMode.Resource;
};
